<template>

</template>

<script>
export default {
  name: 'DispatchLoadOrders'
}
</script>